const getContrastRatio = (hex: string) => {
  const normalize = hex.replace("#", "")
  const fullHex =
    normalize.length === 3
      ? normalize
          .split("")
          .map((character) => character + character)
          .join("")
      : normalize

  const [red, green, blue] = [
    parseInt(fullHex.slice(0, 2), 16),
    parseInt(fullHex.slice(2, 4), 16),
    parseInt(fullHex.slice(4, 6), 16),
  ]

  const toLinear = (value: number) => {
    const scaled = value / 255
    return scaled <= 0.03928
      ? scaled / 12.92
      : ((scaled + 0.055) / 1.055) ** 2.4
  }

  const luminance =
    0.2126 * toLinear(red) + 0.7152 * toLinear(green) + 0.0722 * toLinear(blue)
  const contrastWithWhite = (1.05 / (luminance + 0.05)).toFixed(2)

  return `${contrastWithWhite}:1`
}

export default getContrastRatio
